import * as React from 'react';
import { useTheme } from 'styled-components';

const NavMaccasIcon = ({ isSelected }: { isSelected: boolean }) => {
	const theme = useTheme();
	const fillColor = isSelected ? theme.primaryBackground : 'white';

	return (
		<svg height="22" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15.8125 1.35714C17.7109 1.35714 19.25 9.25571 19.25 19H22C22 8.50657 19.2298 0 15.8125 0C13.8682 0 12.1339 2.55686 11 6.5541C9.86608 2.55686 8.13175 0 6.1875 0C2.77108 0 0 8.50657 0 19H2.75092C2.75092 9.25662 4.29 1.35714 6.1875 1.35714C8.08592 1.35714 9.625 8.64862 9.625 17.6429H12.375C12.375 8.64862 13.9141 1.35714 15.8125 1.35714Z"
				fill={fillColor}
			/>
		</svg>
	);
};

export default NavMaccasIcon;
